import { createSlice } from "@reduxjs/toolkit";

export const createUserInfoSlice = () => {
  const userInfoSlice = createSlice({
    name: "userInfo",
    initialState: null,
    reducers: {
      setUserInfo: (state, action) => {
        return action.payload;
      },
      resetUserInfo: (state) => {
        return null;
      },
    },
  });

  return userInfoSlice;
};

export const createUniversityUserSlice = () => {
  const universityUserSlice = createSlice({
    name: "universityUser",
    initialState: {
      data: [],      
      loading: true,
    },
    reducers: {
      setUniversityUser: (state, action) => {
        state.data = action.payload;
        state.loading = false; 
      },
      resetUniversityUser: (state) => {
        state.data = [];
        state.loading = false;
      },
      setUniversityUserLoading: (state, action) => {
        state.loading = action.payload; 
      },
    },
  });

  return universityUserSlice;
};

// export const createGlobalSlice = () => {
//   const globalSlice = createSlice({
//     name: "global",
//     initialState: {
//       globalUnread: 0,
//     },
//     reducers: {
//       setGlobalUnread: (state, action) => {
//         const delta = action.payload ?? 0;

//         state.globalUnread = Math.max(
//           0,
//           (state.globalUnread ?? 0) + delta
//         );
//       },
//       resetGlobalUnread: (state) => {
//         state.globalUnread = 0;
//       },
//     },
//   });

//   return globalSlice;
// };

